import { Star } from "lucide-react";
import Card from "@/components/ui/Card";
import Button from "@/components/ui/Button";

const SuccessMessage = ({ currentLang, onExploreMore }) => {
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Card>
        <Card.Content className="p-8 text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Star className="h-8 w-8 text-green-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            {currentLang === "ar" ? "تم إرسال طلبك بنجاح!" :
             currentLang === "fr" ? "Votre demande a été envoyée avec succès!" :
             "Your request has been sent successfully!"}
          </h2>
          <p className="text-gray-600 dark:text-gray-300 mb-8">
            {currentLang === "ar" ? 
              "شكرًا لاهتمامك بالشراكة مع جهاز مشروعات الخدمة الوطنية. سيتم التواصل معك خلال 5 - 7 أيام عمل." :
             currentLang === "fr" ? 
              "Merci de votre intérêt pour un partenariat avec l'Organisation des Projets de Service National. Nous vous contacterons dans 5 à 7 jours ouvrables." :
              "Thank you for your interest in partnering with the National Service Projects Organization. We will contact you within 5-7 business days."}
          </p>
          <Button onClick={onExploreMore}>
            {currentLang === "ar" ? "استكشاف المزيد" :
             currentLang === "fr" ? "Explorer plus" : "Explore More"}
          </Button>
        </Card.Content>
      </Card>
    </div>
  );
};

export default SuccessMessage;